module.exports = __webpack_public_path__ + "img/naver_step1.f7379a14.png";